export default {
    calculateDateEstimee: function(commande, selectedGroupOption = null) {
        function isJourOuvre(date) {
            // dimanche (0) - samedi (6) - jours fériés
            if(date.getDay() === 0 || date.getDay() === 6 || isJourFerie(date)) {
                return false
            }
            return true
        }
        function isJourFerie(date){
            let an = date.getFullYear()
            var JourAn = new Date(date.getFullYear(), "00", "01")
            var FeteTravail = new Date(an, "04", "01")
            var Victoire1945 = new Date(an, "04", "08")
            var FeteNationale = new Date(an,"06", "14")
            var Assomption = new Date(an, "07", "15")
            var Toussaint = new Date(an, "10", "01")
            var Armistice = new Date(an, "10", "11")
            var Noel = new Date(an, "11", "25")
            var SaintEtienne = new Date(an, "11", "26")            
            var G = an%19
            var C = Math.floor(an/100)
            var H = (C - Math.floor(C/4) - Math.floor((8*C+13)/25) + 19*G + 15)%30
            var I = H - Math.floor(H/28)*(1 - Math.floor(H/28)*Math.floor(29/(H + 1))*Math.floor((21 - G)/11))
            var J = (an*1 + Math.floor(an/4) + I + 2 - C + Math.floor(C/4))%7
            var L = I - J
            var MoisPaques = 3 + Math.floor((L + 40)/44)
            var JourPaques = L + 28 - 31*Math.floor(MoisPaques/4)
            var Paques = new Date(an, MoisPaques-1, JourPaques)
            var VendrediSaint = new Date(an, MoisPaques-1, JourPaques-2)
            var LundiPaques = new Date(an, MoisPaques-1, JourPaques+1)
            var Ascension = new Date(an, MoisPaques-1, JourPaques+39)
            var Pentecote = new Date(an, MoisPaques-1, JourPaques+49)
            var LundiPentecote = new Date(an, MoisPaques-1, JourPaques+50)            
            const joursFeries = new Array(JourAn, VendrediSaint, Paques, LundiPaques, FeteTravail, Victoire1945, Ascension, Pentecote, LundiPentecote, FeteNationale, Assomption, Toussaint, Armistice, Noel, SaintEtienne)
            if (joursFeries.find(el => el.getDate() === date.getDate() && el.getMonth() === date.getMonth()) !== undefined) {
                return true
            }
            return false
        }
        let group = selectedGroupOption
        if(group == null) {
            group = commande.commande_has_groupe_options.find(e => e.groupe_option.groupe.libelle === 'Affranchissement').groupe_option
        }
        let delaiLivraison = _.toInteger("0"+group.metadata)
        let dateEstimee = new Date(Date.parse(commande.date_remise_en_poste)+delaiLivraison*60*60*1000)            
        let dateDebut = new Date(Date.parse(commande.date_remise_en_poste))
        while (dateDebut <= dateEstimee) {
            // si jour non ouvré la date de remise est repoussé d'un jour
            if(!isJourOuvre(dateDebut)) {
                dateEstimee.setDate(dateEstimee.getDate() + 1)
            }
            dateDebut.setDate(dateDebut.getDate() + 1)
        }
        return dateEstimee.toJSON().slice(0, 10)
    }

}